import { tConfigList } from "oweb";
const
	VERSION = "3.0.0",
	DEBUG = false,
	NAME = 'SondXpress',
	SITE_NAME = 'sondxpress',
	WEB_SITE_HOST = 'sondxpress.com',
	ANDROID_ID = 'com.sondxpress.app',
	UPDATE_SRC = "http://app.sondxpress.com/app/android.js",
	LOGO_SRC = require("../assets/images/icon_sx_full.png");

let
	w_loc = window.location,
	w_doc = window.document,
	html_reg = /[^/]+\.html$/i,
	base_uri = w_doc.baseURI || w_loc.origin,
	api_url = `http://api.${ WEB_SITE_HOST }`,
	app_use_hash = true,
	app_url = app_use_hash
		? w_loc.protocol + "//" + w_loc.host + w_loc.pathname.replace(html_reg, "")
		: base_uri
			.replace(html_reg, "")
			.replace(w_loc.hash, "");

if (DEBUG) {
	if ("cordova" in window) {
		// we are loading web app in mobile app and in a shared network
		// - wifi
		// when in shared network (like wifi) this is your machine/server ip address
		let server_address = "http://192.168.12.1/";
		api_url = `${ server_address }${ SITE_NAME }/api/`;
	} else if (window.location.protocol !== "file:") {
		// we launch app from file browser
		api_url = "../api/";
	} else {
		// we are loading web app from file:///
		api_url = `http://localhost/${ SITE_NAME }/api/`;
	}
}

export default {
	"!OW_APP_NAME": NAME,
	"!OW_APP_VERSION": VERSION,
	"!OW_APP_LOCAL_BASE_URL": app_url,
	"!OW_APP_ROUTER_HASH_MODE": app_use_hash,
	"!OW_APP_ALLOWED_COUNTRIES": [ "bj" ],

	"OW_APP_DEFAULT_LANG": "fr",
	"OW_APP_LOGO_SRC": LOGO_SRC,
	"OW_APP_ANDROID_ID": ANDROID_ID,
	"OW_APP_UPDATER_SCRIPT_SRC": UPDATE_SRC,

	"!OZ_API_KEY_HEADER_NAME": "ozone-api-key",
	"!OZ_API_REAL_METHOD_HEADER_NAME": "ozone-real-method",
	"!OZ_API_KEY": "FC20C0B1-4ADC746F-19A39CB1-C634F6C9",
	"!OZ_API_BASE_URL": api_url,

	"!OZ_CODE_REG": "^[0-9]{6}$",
	"!OZ_USER_NAME_MIN_LENGTH": 3,
	"!OZ_USER_NAME_MAX_LENGTH": 60,
	"!OZ_PASS_MIN_LENGTH": 6,
	"!OZ_PASS_MAX_LENGTH": 60,
	"!OZ_USER_MIN_AGE": 12,
	"!OZ_USER_MAX_AGE": 100,
	"!OZ_PPIC_MIN_SIZE": 150,
	"!OZ_USER_ALLOWED_GENDERS": [ "Male", "Female" ]
} as tConfigList;
